<script setup>
import ThePlaygrounds from "@/components/sections/ThePlaygrounds.vue";
import TheEvents from "@/components/sections/TheEvents.vue";
import TheFaq from "@/components/sections/TheFaq.vue";
</script>
<template>
	<ThePlaygrounds />
	<TheEvents />
	<TheFaq />
</template>
<style lang="scss" scoped></style>
